import moment from '@this/lib/moment';
import type { Approver } from '@this/domain/trip_report/approver';
import type { Moment } from '@this/lib/moment';
import type { InAdvanceApproverCandidateArgs } from '@this/domain/in_advance_approver_candidate';
import { InAdvanceApproverCandidate } from '@this/domain/in_advance_approver_candidate';

export interface InAdvanceApprovalResponseArgs {
  id: number;
  trip_id: number;
  applicant_id: number;
  approver_id: number;
  status: number;
  reject_reason: string;
  cancel_reason: string;
  approve_reason: string;
  approved_at: string;
  approve_stage: number;
  approval_channel_id: number;
  rejected_at: string;
  approver?: Approver;
  in_advance_approver_candidates: InAdvanceApproverCandidateArgs[];
}

export type InAdvanceApprovalArgs = {
  id: number;
  tripId: number;
  applicantId: number;
  approverId: number;
  status: number;
  rejectReason: string;
  cancelReason: string;
  approveReason: string;
  approvedAt: Moment | null;
  rejectedAt: Moment | null;
  approveStage: number;
  approvalChannelId: number;
  approver: Approver | null;
  inAdvanceApproverCandidates: InAdvanceApproverCandidate[];
};

export const convertInAdvanceApprovalResponseToArgs = (response: InAdvanceApprovalResponseArgs) => {
  const args: InAdvanceApprovalArgs = {
    id: response.id,
    tripId: response.trip_id,
    applicantId: response.applicant_id,
    approverId: response.approver_id,
    status: response.status,
    rejectReason: response.reject_reason,
    cancelReason: response.cancel_reason,
    approveReason: response.approve_reason,
    approvedAt: response.approved_at ? moment(response.approved_at) : null,
    rejectedAt: response.rejected_at ? moment(response.rejected_at) : null,
    approveStage: response.approve_stage,
    approvalChannelId: response.approval_channel_id,
    approver: response.approver || null,
    inAdvanceApproverCandidates: response.in_advance_approver_candidates.map(
      candidate => new InAdvanceApproverCandidate(candidate)
    )
  };
  return args;
};

export class InAdvanceApproval {
  id: number;

  tripId: number;

  applicantId: number;

  approverId: number;

  status: number;

  rejectReason: string;

  cancelReason: string;

  approveReason: string;

  approvedAt: Moment | null;

  rejectedAt: Moment | null;

  approveStage: number;

  approvalChannelId: number;

  approver: Approver | null;

  inAdvanceApproverCandidates: InAdvanceApproverCandidate[] = [];

  constructor(args: InAdvanceApprovalArgs) {
    this.id = args.id;
    this.tripId = args.tripId;
    this.applicantId = args.applicantId;
    this.approverId = args.approverId;
    this.status = args.status;
    this.rejectReason = args.rejectReason;
    this.cancelReason = args.cancelReason;
    this.approveReason = args.approveReason;
    this.approvedAt = args.approvedAt;
    this.rejectedAt = args.rejectedAt;
    this.approveStage = args.approveStage;
    this.approvalChannelId = args.approvalChannelId;
    this.approver = args.approver ? args.approver : null;
    this.inAdvanceApproverCandidates = args.inAdvanceApproverCandidates;
  }

  get statusName() {
    switch (this.status) {
      case 0:
        return '承認待ち';
      case 1:
        return '承認済み';
      case 2:
        return '却下';
      case 3:
        return 'キャンセル';
      case 4:
        return '申請中';
      default:
        return '';
    }
  }

  get isApproved() {
    return this.status === 1;
  }

  get isRejected() {
    return this.status === 2;
  }
}
